import React from 'react';
import { Row, Col, Card, Statistic, Progress } from 'antd';
import FeatherIcon from 'feather-icons-react';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from 'utility/utility';
import { ProjectStatisticsDto } from 'api/models';

const ProjectDetailsHeader = ({ statistics, loading }: { statistics?: ProjectStatisticsDto; loading?: boolean }) => {
  const { t } = useTranslation();

  return (
    <div>
      <Row gutter={[16, 16]} justify="center">
        <Col xs={24} sm={12} md={8}>
          <Card bordered={false} style={{ textAlign: 'center' }} loading={loading}>
            <FeatherIcon icon="trending-up" size={24} style={{ marginBottom: 8, color: '#52c41a' }} />
            <Statistic
              title={t('projects:total-income', 'Total Income')}
              value={formatCurrency(statistics?.totalIncome || 0)}
              precision={2}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card bordered={false} style={{ textAlign: 'center' }} loading={loading}>
            <FeatherIcon icon="trending-down" size={24} style={{ marginBottom: 8, color: '#f5222d' }} />
            <Statistic
              title={t('projects:total-expenses', 'Total Expenses')}
              value={formatCurrency(statistics?.totalExpenses || 0)}
              precision={2}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card bordered={false} style={{ textAlign: 'center' }} loading={loading}>
            <FeatherIcon icon="dollar-sign" size={24} style={{ marginBottom: 8, color: '#1890ff' }} />
            <Statistic
              title={t('projects:net-revenue', 'Net Revenue')}
              value={formatCurrency(statistics?.netRevenue || 0)}
              valueStyle={{ color: (statistics?.netRevenue || 0) >= 0 ? '#52c41a' : '#f5222d' }}
              precision={2}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} justify="center" className="mt-4">
        <Col xs={24} sm={12} md={8}>
          <Card bordered={false} style={{ textAlign: 'center' }} loading={loading}>
            <FeatherIcon icon="box" size={24} style={{ marginBottom: 8, color: '#722ed1' }} />
            <Statistic title={t('projects:total-categories', 'Total Categories')} value={statistics?.totalCategories || 0} />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card bordered={false} style={{ textAlign: 'center' }} loading={loading}>
            <FeatherIcon icon="box" size={24} style={{ marginBottom: 8, color: '#13c2c2' }} />
            <Statistic title={t('projects:total-units', 'Total Units')} value={statistics?.totalUnits || 0} />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card bordered={false} style={{ textAlign: 'center' }} loading={loading}>
            <FeatherIcon icon="check-circle" size={24} style={{ marginBottom: 8, color: '#faad14' }} />
            <Statistic title={t('projects:total-deals', 'Total Deals')} value={statistics?.totalDeals || 0} />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ProjectDetailsHeader;
